const contextReducer = (
  state = { uploads: {}, uploading: false, uploaded: [], error: {} },
  { type, code, name, files, error, uploading, progress }
) => {
  switch (type) {
    case "success": {
      const { [code]: value, ...uploads } = state.uploads;

      if (!Array.isArray(files)) {
        return state;
      }

      return {
        ...state,
        uploads,
        uploading,
        uploaded: [...state.uploaded, ...files],
      };
    }
    case "error": {
      const upload = state.uploads[code];

      const uploads = upload
        ? {
            ...state.uploads,
            [code]: {
              ...upload,
              uploading: false,
              errorMessage: error?.message ?? "",
              error: true,
            },
          }
        : state.uploads;

      return {
        ...state,
        uploads,
        uploading,
        error,
      };
    }
    case "cancel": {
      const { [code]: value, ...uploads } = state.uploads;
      return { ...state, uploads, uploading };
    }
    case "update": {
      const upload = state.uploads[code];

      if (!upload) {
        return state;
      }

      return {
        ...state,
        uploads: {
          ...state.uploads,
          [code]: { ...upload, progress },
        },
      };
    }
    case "init": {
      return {
        ...state,
        uploading: true,
        uploads: {
          ...state.uploads,
          [code]: {
            code,
            name,
            type: `local`,
            progress: 0,
            uploading: true,
            error: false,
            errorMessage: ``,
          },
        },
      };
    }
    case "retry": {
      const upload = state.uploads[code];

      if (!upload) {
        return state;
      }

      return {
        ...state,
        uploading,
        uploads: {
          ...state.uploads,
          [code]: {
            ...upload,
            progress: 0,
            uploading: true,
            error: false,
            errorMessage: ``,
          },
        },
        error: {},
      };
    }
    case "merge": {
      if (!Array.isArray(files)) {
        return state;
      }

      return { ...state, uploaded: [...state.uploaded, ...files] };
    }
    case "clear": {
      return { uploads: {}, uploading: false, uploaded: [], error: {} };
    }
    case "remove": {
      const uploaded = state.uploaded.filter((item) => item.code !== code);
      return { ...state, uploaded };
    }
    default:
      return state;
  }
};

const reducer = (state = {}, { context, ...action }) => {
  return { ...state, [context]: contextReducer(state[context], action) };
};

export default reducer;
